import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper'
import { EMAIL_ACTION } from './actionTypes'

export const EmailActions = {
	subscribe:          RequestActionHelper.getActionCreatorFetch(EMAIL_ACTION.SUBSCRIBE),
}
